export default __webpack_public_path__ + "static/media/LunchVoucher.9001d4b3.png";